export default "__VITE_ASSET__D54tT1tV__"